import React, { useContext, useEffect, useState } from "react";
import GlobalContext from "../context/GlobalContext";
import * as api from "../api/index";
import AdminUserDetails from "./AdminUserDetails";
import { HashLoader } from "react-spinners";
//import AdminEvenDetails from "./AdminEvenDetails";

const AdminPanel = () => {
  const { userDetails } = useContext(GlobalContext);
  const [usersData, setUsersData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [showuserData, setShowUserData] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.GetAdminData().then((data) => {
      setUsersData(data.data.usersResult);
      setEventsData(data.data.eventsResult);
      setLoading(false);
    });
  }, []);

  return (
    <div className="admin-flex-columns">
      <header className="flex-rows-end-center">
        <div className="px-4 py-2 flex items-center">
          <button
            onClick={() => setShowUserData(true)}
            className="border rounded py-2 px-4 mr-5"
          >
            Users
          </button>
          {/* <button
            onClick={() => setShowUserData(false)}
            className="border rounded py-2 px-4 mr-5"
          >
            Events
          </button> */}
        </div>
      </header>
      {/* {showuserData ? (
        <AdminUserDetails usersData={usersData} setUsersData ={setUsersData} />
      ) : (
        <AdminEvenDetails eventsData={eventsData} />
      )} */}
      {loading ? (
        <HashLoader size={150} color={"#2A25EC"} loading={loading}></HashLoader>
      ) : (
        <AdminUserDetails usersData={usersData} setUsersData={setUsersData} />
      )}
    </div>
  );
};

export default AdminPanel;
